import { render, staticRenderFns } from "./ApplicationsByCouncilArea.vue?vue&type=template&id=149ad365"
import script from "./ApplicationsByCouncilArea.vue?vue&type=script&lang=js"
export * from "./ApplicationsByCouncilArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports